/**
 * Shell. Keyboard-navigable, responsive, and honest in the nav itself: a view with no data
 * source is marked before you click it, not after.
 */
import { useEffect, useState } from 'react';
import { VIEWS, type ViewDef } from './views';

const GROUPS = ['Monitor', 'Respond & prepare', 'Configure'] as const;

export function App() {
  const [id, setId] = useState<string>(() => location.hash.slice(1) || 'overview');

  useEffect(() => {
    const onHash = () => setId(location.hash.slice(1) || 'overview');
    addEventListener('hashchange', onHash);
    return () => removeEventListener('hashchange', onHash);
  }, []);

  const view: ViewDef = VIEWS.find((v) => v.id === id) ?? VIEWS[0]!;

  useEffect(() => { document.title = `${view.title} · Greyhive Operations`; }, [view.title]);

  return (
    <div className="shell">
      <a className="skip" href="#main">Skip to content</a>

      <nav className="rail" aria-label="Views">
        <div className="brand">
          <div className="mark">GREYHIVE</div>
          <span className="env">Operations · production</span>
        </div>

        {GROUPS.map((g) => (
          <div key={g}>
            <div className="navgroup"><span>{g}</span></div>
            {VIEWS.filter((v) => v.group === g).map((v) => (
              <button key={v.id}
                aria-current={v.id === view.id ? 'page' : undefined}
                onClick={() => { location.hash = v.id; }}>
                {v.title}
                {v.coverage === 'none' && <span className="blind">no data</span>}
              </button>
            ))}
          </div>
        ))}
      </nav>

      <main className="main" id="main">
        <div className="wrap">
          <header className="head">
            <h1>{view.title}</h1>
            <p>{view.blurb}</p>
          </header>
          {view.render()}
          <div style={{ height: 80 }} />
        </div>
      </main>
    </div>
  );
}
